// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__FSfHB","primary":"Button_primary__jIynG","secondary":"Button_secondary__rDUom","ghost":"Button_ghost__N+NYd","fullWidth":"Button_fullWidth__9dpTm"};